export default __webpack_public_path__ + "static/media/computersslack.63139ce1.png";